/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TaskRoute extends Route {
  // Methods
  @service
  store;

  model(params) {
    return hash({
      task: this.store.findRecord('cron/task', params.task_id),
      logs: this.store.query('cron/log', { taskId: params.task_id }),
    });
  }

  /**
   * resetController calls the reset handler on the controller.
   *
   * @param controller
   */
  resetController(controller) {
    controller.reset();
  }
}
